import React from 'react';
import { withContent } from '../../../hoc/withContext';
import './IbexBlock.scss';
import { IContent } from '../../../types';
import Image from '../../UI/Image/Image';
import { getShopURL, sendEvent } from '../../../utils';

// @ts-ignore
import Fade from 'react-reveal/Fade';

interface IbexBlockProps {
  context?: IContent;
}

const IbexBlock = ({ context }: IbexBlockProps) => {
  const { ibex } = context;
  const { is_active, title, description, cta } = ibex;

  return is_active && (
    <div className="block-container-ibex">
      <div className="block-ibex">
        <Image
          className={["shadow"]}
          imageName="shadow-rocksmith-plus.png"
          altText=""
        />
        <div className="content">
          <Fade delay={100} duration={600}>
            <div className="left-content">
              <div className="block-title">{title}</div>
              {description && (
                <div className="description" dangerouslySetInnerHTML={{ __html: description}} />
              )}
              {cta && cta.link && cta.title && (
                <div className="action">
                  <a
                    className={"store-outline"}
                    href={getShopURL() + cta.link}
                    onClick={() => sendEvent(cta.tracking)}
                    data-alt-text={cta.title}
                  >
                    <span>{cta.title}</span>
                  </a>
                </div>
              )}
            </div>
          </Fade>
          <div className="right-content">
            <Fade delay={200} duration={600}>
              <div className="logo">
                <Image
                  imageName="logo-rocksmith-plus.svg"
                  altText="Logo Rocksmith+"
                />
              </div>
            </Fade>
            <Fade delay={300} duration={600}>
              <div className="image">
                <Image
                  imageName="image-rocksmith-plus.png"
                  altText=""
                />
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withContent(IbexBlock);
